export class ContributorStripeAccountErrorModel {
    public status: number;
    public errors: Array<string>;

    constructor() {
        this.errors = new Array<string>();
    }
}
